export default __webpack_public_path__ + "static/media/java.fdabd4e1.png";